import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e4f104c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-selected", "title"]
const _hoisted_2 = { class: "px-2" }

import { ProductLabelType, ProductSpotModel } from '@/types/productServerApi';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import { computed } from 'vue';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import OverlaySpotImage from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotImage.vue';
import OverlaySpotTitle from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotTitle.vue';
import OverlaySpotPrice from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotPrice.vue';
import useProductAngleImage from '@/shared/product/details/useProductAngleImage';
import ProductSplashLabels from '@/shared/product/splash/ui/ProductSplashLabels.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFamilySpot',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ProductSpotModel;
}



const labels = useBlockLabels();
const { variantId } = useProductDetailData();
const { clearActiveCustomizerOverlay } = useCustomizer();
const { updateSku } = useProductDetailPage();
const { getMaybeAngleImageSku } = useProductAngleImage();

const isSelected = computed<boolean>(() => props.item.sku === variantId.value);

const filteredLabels = computed(() => props.item.labels?.filter((label) => label.type !== ProductLabelType.ProductSpot));

const select = () => {
    if (isSelected.value) {
        return;
    }
    const sku = props.item.sku;
    clearActiveCustomizerOverlay(true);
    updateSku(sku);
};

const imageSku = computed<string>(() => getMaybeAngleImageSku(props.item.sku, props.item.imageProperties));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    "aria-selected": _unref(isSelected),
    title: _unref(isSelected) ? __props.item.name : _ctx.$dictionary.formatNamed(_unref(labels).overlaySelectItem, { name: __props.item.name }),
    class: _normalizeClass(["flex flex-col-reverse justify-end h-full relative", { 'cursor-pointer': !_unref(isSelected) }]),
    onClick: select
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(OverlaySpotTitle, {
        title: __props.item.name
      }, null, 8, ["title"]),
      _createVNode(OverlaySpotPrice, {
        price: __props.item.price,
        "variant-id": __props.item.sku
      }, null, 8, ["price", "variant-id"]),
      (!_unref(isSelected))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "sr-only",
            onClick: select
          }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).overlaySelectItem, { name: __props.item.name })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["relative mb-15 border-2 border-white", { 'selected': _unref(isSelected) }])
    }, [
      _createVNode(OverlaySpotImage, {
        sku: _unref(imageSku),
        "cache-bust": __props.item.imageProperties?.version
      }, null, 8, ["sku", "cache-bust"]),
      (__props.item.labels)
        ? (_openBlock(), _createBlock(ProductSplashLabels, {
            key: 0,
            labels: _unref(filteredLabels),
            selected: _unref(isSelected)
          }, null, 8, ["labels", "selected"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1))
}
}

})